import store from "@tt-app/store";

import { VUEX_ROOT_ACTION_NAMES } from "@tt-app/constants";

const { PUSH_NOTIFICATION_TOAST } = VUEX_ROOT_ACTION_NAMES;

function dispatchToast() {
  store.dispatch(PUSH_NOTIFICATION_TOAST, {
    text: "クリップボードにコピーしました",
    timespan: 3000
  });
}

async function copyWithClipBoarAPI(el: any) {
  try {
    const clipboardAPI = navigator.clipboard;

    await clipboardAPI.writeText(el.href);

    dispatchToast();
  } catch (error) {
    console.log("clipboard API copy failed:", error);
  }
}

function createAndAppendTextAreaWithValue(text: string) {
  const textArea = document.createElement("textArea") as HTMLTextAreaElement;

  textArea.value = text;

  document.body.appendChild(textArea);

  return textArea;
}

function selectText(textArea: HTMLTextAreaElement) {
  const range = document.createRange();
  range.selectNodeContents(textArea);

  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  textArea.setSelectionRange(0, 999999);
}

function copyText(textArea: HTMLTextAreaElement) {
  document.execCommand("copy");
  document.body.removeChild(textArea);
}

function copyWithTextArea(el: any) {
  try {
    const textArea = createAndAppendTextAreaWithValue(el.href);

    selectText(textArea);

    copyText(textArea);

    dispatchToast();
  } catch (error) {
    console.log("textArea copy failed:", error);
  }
}

export const vCopy = {
  bind: (el: any) => {
    el.addEventListener("click", (event: MouseEvent) => {
      event.preventDefault();

      const clipboardAPI = navigator.clipboard;

      if (clipboardAPI) {
        copyWithClipBoarAPI(el);
      } else {
        copyWithTextArea(el);
      }
    });
  }
};
